import { ComponentThemeProps } from "@insite/mobius/globals/baseTheme";
import { css } from "styled-components";

export const modal: ComponentThemeProps["modal"] = {
    sizeVariants: {
        small: 500,
        medium: 800,
        large: 1200,
    },
    defaultProps: {
        cssOverrides: {
            headlineTypography: css`
                font-size: 24px;
                margin-bottom: 0;
                color: ${({ theme }) => theme.colors.primary.main};
            `,
            modalTitle: css`
                border-bottom: none;
            `,
            modalBody: css`
                border-radius: 10px;
            `,
        },
        closeButtonProps: {
            css: css`
                &:hover {
                    svg,
                    [class*="IconWrapper"] {
                        color: ${({ theme }) => theme.colors.primary.contrast};
                    }
                } 
            `,
        },
    },
};
